import { SettingsSection } from '@components'

import { Button, Checkbox, FormItemsGroup } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useOrganizationBrand } from '../../../../hooks/useOrganizationBrand'
import { useSegment } from '../../../../hooks/useSegment'
import { useUserPrivacyForm } from './hooks/useUserPrivacyForm'

export const UserPrivacySettings = (): ReactElement => {
  const { t } = useTranslation()
  const { Form, FormItem, isLoading, isSubmitting } = useUserPrivacyForm()
  const { isBrandAgeras } = useOrganizationBrand()
  const { track } = useSegment()

  // window.CookieConsent is injected by the Cookie Information consent banner (loaded via Google Tag Manager)
  // renew() reopens the consent modal
  const handleManageCookieButtonClick = useCallback(() => {
    const renewCookieConsent = window.CookieConsent?.renew
    if (typeof renewCookieConsent === 'function') {
      track('XXX - Profile Settings - Privacy - Cookie Preferences Opened (Client)')
      renewCookieConsent()
    }
  }, [track])

  return (
    <>
      <SettingsSection>
        <Form>
          <SettingsSection.Content
            title={t('settings.user.privacy_settings')}
            subtitle={t('settings.user.privacy_settings.subtitle')}
          >
            <FormItemsGroup>
              <FormItem
                name="isSupportAccessAllowed"
                render={({ field: { onChange, value } }) => (
                  <Checkbox checked={value} onChange={onChange}>
                    {t('settings.user.privacy.supportAccess')}
                  </Checkbox>
                )}
              />
            </FormItemsGroup>
          </SettingsSection.Content>
          <SettingsSection.Footer>
            <Button loading={isLoading || isSubmitting} size="md" type="submit">
              {t('settings.user.privacy.save_changes')}
            </Button>
          </SettingsSection.Footer>
        </Form>
      </SettingsSection>
      {isBrandAgeras && (
        <SettingsSection>
          <SettingsSection.Content
            subtitle={t('settings.user.privacy.cookies.subtitle')}
            title={t('settings.user.privacy.cookies.title')}
          >
            <Button onClick={handleManageCookieButtonClick} size="md" type="button">
              {t('settings.user.privacy.cookies.manage_button')}
            </Button>
          </SettingsSection.Content>
        </SettingsSection>
      )}
    </>
  )
}
